<template>
  <Selection :url="url" :items="items"></Selection>
</template>
<script>
import axios from "axios";
import Selection from "@/components/Selection.vue";

export default {
  name: "SelectionView",
  components: {
    Selection,
  },
  data() {
    return {
      width: "",
      height: "",
      loading: false,
      percent: 10,
      url: "https://mhburo.bitrix24.ru/rest/6/qb5hjgskudojsmwi/",
      items: [],
      currency: [
        { text: "USD", id: "$", idCrm: "90" },
        { text: "EUR", id: "€", idCrm: "88" },
        { text: "RUB", id: "₽", idCrm: "86" },
      ],
      optionsRooms: [
        { text: "1", id: "1054822" },
        { text: "2", id: "1054824" },
        { text: "3", id: "1054826" },
        { text: "4", id: "1054828" },
        { text: "5", id: "1054830" },
        { text: "6+", id: "1054832" },
      ],
      typePropetys: [
        { text: "Жилая", id: "1084350" },
        { text: "Загородная", id: "1084378" },
        { text: "Коммерческая", id: "1084346" },
      ],
      typeAparts: [
        { text: "Апартамент", id: "1084380" },
        { text: "Квартира", id: "1084382" },
        // { text: "Квартиры с террасами", id: "1084394" },
        { text: "Коттедж", id: "1084386" },
        // { text: "Лофт", id: "1084390" },
        { text: "Мансарда", id: "1084396" },
        { text: "Особняк", id: "1084392" },
        { text: "Офис", id: "1084398" },
        { text: "Пентхаус", id: "1084388" },
        { text: "Ритейл", id: "1084400" },
        { text: "Таунхаус", id: "1084384" },
        { text: "Участок", id: "1084412" },
      ],
      otcType: [
        { text: "С отделкой", id: "66" },
        { text: "whitebox", id: "68" },
        { text: "Без отделки", id: "70" },
      ],
      typeDeal: [
        { text: "Продажа", id: "92" },
        { text: "Аренда", id: "94" },
        { text: "Продажа", id: "44" },
        { text: "Аренда", id: "46" },
      ],
      statusDeal: [
        { text: "Новостройка", id: "1083376" },
        { text: "Вторичка", id: "1083378" },
      ],
      tags: [
        { text: "Архив", id: "1081562" },
        { text: "CRM", id: "1081560" },
      ],
      optionsResidense: [],
      optionsStreet: [],
      optionsArea: [],
    };
  },
  methods: {
    initObj(objData) {
      console.log({ objData });
      const residense = objData.ufCrm6_1683278425
        ? this.optionsResidense.filter(
            (e) => e.id == objData.ufCrm6_1683278425
          )[0]
          ? this.optionsResidense.filter(
              (e) => e.id == objData.ufCrm6_1683278425
            )[0].value
          : ""
        : "";
      const area = objData.ufCrm6_1683278452
        ? this.optionsArea.filter((e) => e.id == objData.ufCrm6_1683278452)[0]
          ? this.optionsArea.filter((e) => e.id == objData.ufCrm6_1683278452)[0]
              .value
          : ""
        : "";
      const street = objData.ufCrm6_1683278462
        ? this.optionsStreet.filter((e) => e.id == objData.ufCrm6_1683278462)[0]
          ? this.optionsStreet.filter(
              (e) => e.id == objData.ufCrm6_1683278462
            )[0].value
          : ""
        : "";

      const mapPrice = objData.opportunity
        ? (Number(objData.opportunity) / 1000000).toFixed(1)
        : "";
        
      const obj = {
        selected: false,
        cian: false,
        name: objData.title,
        title: objData.title,
        id: objData.id,
        mapPrice:
          mapPrice.split(".")[1] == 0 ? mapPrice.split(".")[0] : mapPrice,
        coordinates: objData.ufCrm6_1721638647
          ? [
              objData.ufCrm6_1721638647.split(" ")[0],
              objData.ufCrm6_1721638647.split(" ")[1],
            ]
          : "",
        map: `https://static-maps.yandex.ru/v1?ll=${
          objData.ufCrm6_1721638647.split(" ")[0]
        },${objData.ufCrm6_1721638647.split(" ")[1]}&size=650,450&z=15&pt=${
          objData.ufCrm6_1721638647.split(" ")[0]
        },${
          objData.ufCrm6_1721638647.split(" ")[1]
        },pm2rdm~37,55&apikey=b8e4bc4e-b6c4-445a-8485-580c4a2af53b`,

        dateActive: objData.ufCrm6_1683221006 ? objData.ufCrm6_1683221006 : "",
        typeDeal: objData.ufCrm6_1683220626
          ? this.typeDeal.filter((e) => e.id == objData.ufCrm6_1683220626)[0]
              .text
          : "", //тип
        typeDealID: objData.ufCrm6_1683220626 ? objData.ufCrm6_1683220626 : "",
        img: {},
        images: [],
        oldImages: [],
        newImages: [],
        urlImages: [],
        fileAdd: [],
        typeAparts: objData.UF_CRM_6_1683220764
          ? this.typeAparts.filter(
              (e) => e.id == objData.UF_CRM_6_1683220764
            )[0].text
          : "", //тип недвижимости
        rooms: objData.ufCrm6_1683705490
          ? this.optionsRooms.filter(
              (e) => e.id == objData.ufCrm6_1683705490
            )[0].text
          : "", //кол-во комнаты
        residense, //жк
        residenseID: objData.ufCrm6_1683278425 ? objData.ufCrm6_1683278425 : "",
        area,
        street,
        address: objData.ufCrm6_1683220890 ? objData.ufCrm6_1683220890 : "", //адресс
        fullPricexls: objData.opportunity
          ? objData.currencyId == "USD"
            ? Number(objData.opportunity) * 95
            : objData.currencyId == "EUR"
            ? Number(objData.opportunity) * 105
            : Number(objData.opportunity)
          : "",
        fullPrice: objData.opportunity
          ? new Intl.NumberFormat("ru-RU").format(objData.opportunity)
          : "", //цена
        squarePrice: objData.ufCrm6_1683220730
          ? new Intl.NumberFormat("ru-RU").format(
              objData.ufCrm6_1683220730.split("|")[0]
            )
          : "",
        currency: objData.currencyId
          ? this.currency.filter((e) => e.text == objData.currencyId)[0]
          : "",
        square: objData.ufCrm6_1683220916 ? objData.ufCrm6_1683220916 : "", //площадь
        landArea: objData.ufCrm6_1700128619688
          ? objData.ufCrm6_1700128619688
          : null, //площадь участка
        heightCeiling: objData.ufCrm6_1696923629155
          ? objData.ufCrm6_1696923629155
          : "", //Высота потолка
        bedroom: objData.ufCrm6_1683705490
          ? this.optionsRooms.filter(
              (e) => e.id == objData.ufCrm6_1683705490
            )[0].text
          : "", //кол-во спален
        status: objData.ufCrm6_1693933072
          ? this.statusDeal.filter((e) => e.id == objData.ufCrm6_1693933072)[0]
              .text
          : "", //новостройка/вторичка
        archive: objData.ufCrm6_1688550985
          ? this.tags.filter((e) => e.id == objData.ufCrm6_1688550985)[0].text
          : "", //теги
        floor: objData.ufCrm6_1683220972
          ? `${objData.ufCrm6_1683220943}/${objData.ufCrm6_1683220972}`
          : "", //этажи
        wc: objData.ufCrm6_1683220958 ? objData.ufCrm6_1683220958 : "", //
        otc: objData.ufCrm6_1683220852
          ? objData.ufCrm6_1683220852 == "1083390"
            ? "С отделкой"
            : this.otcType.filter((e) => e.id == objData.ufCrm6_1683220852)[0]
                .text
          : "",
        otcID: objData.ufCrm6_1683220852 ? objData.ufCrm6_1683220852 : "",
        responsible: objData.ufCrm6_1683221053 ? objData.ufCrm6_1683221053 : "",
        commision: objData.ufCrm6_1683221029 ? objData.ufCrm6_1683221029 : "",
        details: objData.ufCrm6_1683220985 ? objData.ufCrm6_1683220985 : "",
        saleTitle: objData.ufCrm6_1691682557 ? objData.ufCrm6_1691682557 : "",
        detailsResidense: objData.ufCrm6_1691682741
          ? objData.ufCrm6_1691682741
          : "",
        showDialog: false,
        drag: false,
        isActive: false,
        orientation: "",
      };
      console.log({ obj });
      if (objData.ufCrm6_1683219573) {
        const diskArray = objData.ufCrm6_1683219573;
        for (const index in diskArray) {
          obj.oldImages.push({
            id: diskArray[index].id,
            url: diskArray[index].urlMachine,
            isMain: false,
            isSecond: false,
            preview: false,
            width: this.width,
            height: this.height,
          });
        }
      }
      if (objData.ufCrm6_1688550914715) {
        const diskArray = objData.ufCrm6_1688550914715;
        for (const index in diskArray) {
          obj.oldImages.push({
            id: diskArray[index].id,
            url: diskArray[index].urlMachine,
            isMain: false,
            isSecond: false,
            preview: false,
            width: this.width,
            height: this.height,
          });
        }
      }
      if (objData.ufCrm6_1683219588) {
        obj.oldImages.unshift({
          id: objData.ufCrm6_1683219588.id,
          url: objData.ufCrm6_1683219588.urlMachine,
          isMain: true,
          isSecond: false,
          preview: false,
          width: this.width,
          height: this.height,
        });
      }

      obj.images.push(...obj.oldImages);
      obj.img = obj.oldImages[0];
      if (obj.images.length > 0) obj.images[0].isMain = true;
      if (obj.images.length > 1) obj.images[1].isSecond = true;
      return obj;
    },
    async getFields() {
      try {
        //жк
        const residenseParams = {
          moduleId: "crm",
          id: 272,
        };
        const residenseData = await axios.post(
          this.url + "userfieldconfig.get",
          residenseParams
        );
        this.optionsResidense.push(...residenseData.data.result.field.enum);
        //районы

        const areaParams = {
          moduleId: "crm",
          id: 274,
        };
        const areaData = await axios.post(
          this.url + "userfieldconfig.get",
          areaParams
        );
        this.optionsArea.push(...areaData.data.result.field.enum);
        //улицы
        const streetParams = {
          moduleId: "crm",
          id: 276,
        };
        const streetData = await axios.post(
          this.url + "userfieldconfig.get",
          streetParams
        );
        this.optionsStreet.push(...streetData.data.result.field.enum);
      } catch (e) {
        console.log(e);
      }
    },
    async getItems() {
      try {
        console.log(this.$route, "params");
        this.items = [];
        const batchParams = {
          halt: 0,
          cmd: {},
        };
        for (const indexObjID in this.$route.query) {
          console.log(this.$route.query[indexObjID]);
          batchParams.cmd[
            `${indexObjID}`
          ] = `crm.item.get?entityTypeId=149&id=${this.$route.query[indexObjID]}`;
        }
        const batchResult = await axios.post(this.url + "batch", batchParams);
        console.log({ batchResult });
        const result = batchResult.data.result.result;
        for (const resIndex in result) {
          const obj = this.initObj(result[resIndex].item);
          this.items.push(obj);
        }
        console.log(this.items);
      } catch (error) {
        console.log({ error });
      }
    },
  },
  async mounted() {
    const onResizewidth = () => (this.width = window.innerWidth);
    onResizewidth();
    window.addEventListener("resize", onResizewidth);
    const onResizeheight = () => (this.height = window.innerHeight);
    onResizeheight();
    window.addEventListener("resize", onResizeheight);

    await this.getFields();
    await this.getItems();
  },
};
</script>
